<template>
  <p class="document__title" :class="activeClass">
    <slot />
  </p>
</template>

<script>
export default {
  props: {
    activeClass: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.document__title {
  font-weight: 900;
  font-size: 16px;
  line-height: 1.5;
  color: $black;
}
</style>
